<template>
  <div>
    <v-card class="mx-auto my-12" max-width="80%">
      <div v-if="alert == true">
        <v-alert type="success">{{ informText }}</v-alert>
      </div>
      <div v-else-if="alert == false">
        <v-alert type="error">{{ informText }}</v-alert>
      </div>

      <v-card-title>Customer Export</v-card-title>

      <v-card-text>
        <v-col>
          <v-select
            label="Template"
            :items="templateList"
            v-model="templateSelected"
          ></v-select>
        </v-col>

        <v-col>
          <v-radio-group v-model="filterData" row label="Export">
            <v-radio label="All" value="All"></v-radio>
            <v-radio label="Matching Filters" value="MatchingFilters"></v-radio>
          </v-radio-group>
        </v-col>

        <v-col v-if="filterData == 'MatchingFilters'">
          <v-autocomplete
            :items="listTags"
            :item-text="(obj) => obj.tag_name"
            :item-value="(obj) => obj._id"
            label="List Tags"
            multiple
            chips
            v-model="listTagsSelected"
            @input="searchInput = null"
            :search-input.sync="searchInput"
          ></v-autocomplete>
        </v-col>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="deep-purple lighten-2"
          dark
          @click="exportData"
          v-if="templateSelected != '' && filterData == 'All' && showBtn"
        >
          Export
        </v-btn>
        <v-btn
          color="deep-purple lighten-2"
          dark
          @click="exportData"
          v-else-if="
            templateSelected != '' &&
            filterData == 'MatchingFilters' &&
            listTagsSelected.length > 0 &&
            showBtn
          "
        >
          Export
        </v-btn>
        <v-btn color="deep-purple lighten-2" disabled v-else> Export </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
//import moment from "moment-timezone";
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "CustomerExport",

  data: () => ({
    templateList: ["google", "facebook", "sendy"],
    listTags: [],
    filterData: "",
    templateSelected: "",
    listTagsSelected: [],
    informText: "",
    showBtn: true,
    alert: null,
    searchInput: null,
  }),

  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },

    async loadData() {
      this.listTags = [];
      this.informText = "";
      var currentSession = await this.$root.$refs.App.currentSession(
        "customerTag-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "tags-v2", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            console.log("tag customer Response: ", response);
            if (response.data.error_message == "") {
              this.listTags = response.data.data.tags;
            } else {
              this.informText = response.data.error_message;
            }
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log(
          "currentSession tag customer-loadData-undefined: ",
          currentSession
        );
      }
    },

    async exportData() {
      this.showBtn = false;
      this.alert = null;
      var item = {
        template: this.templateSelected,
        export: this.filterData,
        filters: {},
      };

      if (this.filterData != "All") {
        item.filters["tags"] = this.listTagsSelected;
      }

      console.log("item: ", item);

      var currentSession = await this.$root.$refs.App.currentSession(
        "customer-exportData"
      );
      if (currentSession.accessToken) {
        await fetch(window.domain + "customers/export-customers", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(item),
        });
      } else {
        console.log(
          "currentSession customer-loadData-undefined: ",
          currentSession
        );
      }

      this.alert = true;
      this.informText =
        "Customer Data has been sent to your email. Please check in inbox or spam";

      await this.sleep(5000);
      this.showBtn = true;
      this.templateSelected = "";
      this.listTagsSelected = [];
      this.filterData = "";
      this.alert = null;
      this.informText = "";
    },
  },

  async mounted() {
    this.roles = await this.$cookies.get("customer");
    if (this.roles.export_customer) {
      console.log("OK");
    } else {
      this.$router.push("/not-authorized");
    }

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      await this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style lang="scss" scoped>
</style>